"use client";

import * as React from "react";

const OrderedOverlayContainerContext = React.createContext<HTMLElement | null>(
  null,
);

export function OrderedOverlayProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [container, setContainer] = React.useState<HTMLDivElement | null>(null);

  return (
    <OrderedOverlayContainerContext.Provider value={container}>
      {children}
      <div
        ref={setContainer}
        className="fixed left-0 top-0 z-modal"
        data-ordered-overlay-host=""
      />
    </OrderedOverlayContainerContext.Provider>
  );
}

export function useOrderedOverlayContainer() {
  return React.useContext(OrderedOverlayContainerContext);
}
